import { RequestService } from '../../services/RequestService';
import { GET_CUSTOMER_COMPANIES_SEARCH } from '../constants';

export const getCustomerCompaniesSearch = (profileId, payload) => {
  return RequestService.get(GET_CUSTOMER_COMPANIES_SEARCH, {
    params: { search_entry: payload, profile_id: profileId },
  });
};
